const config = {
  PORT: process.env.PORT,
  API_URL: process.env.REACT_APP_API_URL,
};

export default config;
